var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.titles, function (item, i) {
        return [
          item.num && _vm.activeInfo
            ? _c(
                "title-block",
                { key: i, attrs: { id: "bm" + item.label } },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "mt-10",
                      staticStyle: { "margin-top": "16px" },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.tableDatas(item.moduleId),
                            "header-cell-style": {
                              background: "#fafafa",
                              color: "#333",
                            },
                            "tooltip-effect": "light",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "序号",
                              align: "center",
                              width: "70",
                            },
                          }),
                          _vm._l(
                            _vm.tableFields(item.moduleId),
                            function (item1, i) {
                              return [
                                item1.field != "id"
                                  ? _c("el-table-column", {
                                      key: i,
                                      attrs: {
                                        label: item1.fieldName,
                                        align: "center",
                                        "show-overflow-tooltip": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                item1.field == "jobReq"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        class: scope.row[i]
                                                          ? "operation-btn"
                                                          : "pointer-e",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.goJobReq(
                                                              scope.row[i]
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("详情")]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "textOverflow",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.columnValue(
                                                              scope.row[i],
                                                              item.moduleId
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                      _c("pagination", {
                        attrs: {
                          pageNum: _vm.tablePage(item.moduleId),
                          total: _vm.tableTotal(item.moduleId),
                        },
                        on: { currentChange: _vm.handleCurrentChange2 },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      }),
      _c("jobReqDetail", { ref: "jobReqDetail" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }